/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiBulkAssignee,
    ApiBulkAssigneeFromJSON,
    ApiBulkAssigneeToJSON,
    ApiBulkStatus,
    ApiBulkStatusFromJSON,
    ApiBulkStatusToJSON,
    ApiRelatedAlertBulkStatus,
    ApiRelatedAlertBulkStatusFromJSON,
    ApiRelatedAlertBulkStatusToJSON,
    ApiSanctionAlerts,
    ApiSanctionAlertsFromJSON,
    ApiSanctionAlertsToJSON,
} from '../models';

export interface UpdateSanctionAlertsAssigneeRequest {
    apiBulkAssignee: ApiBulkAssignee;
}

export interface UpdateSanctionAlertsStatusesRequest {
    apiBulkStatus: ApiBulkStatus;
}

export interface UpdateScreeningRelatedAlertsStatusesRequest {
    screeningAlertId: number;
    apiRelatedAlertBulkStatus: ApiRelatedAlertBulkStatus;
}

/**
 * 
 */
export class SanctionAlertsBulkApi extends runtime.BaseAPI {

    /**
     * Update sanction alerts assignee
     */
    async updateSanctionAlertsAssigneeRaw(requestParameters: UpdateSanctionAlertsAssigneeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiSanctionAlerts>> {
        if (requestParameters.apiBulkAssignee === null || requestParameters.apiBulkAssignee === undefined) {
            throw new runtime.RequiredError('apiBulkAssignee','Required parameter requestParameters.apiBulkAssignee was null or undefined when calling updateSanctionAlertsAssignee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/assignees`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBulkAssigneeToJSON(requestParameters.apiBulkAssignee),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiSanctionAlertsFromJSON(jsonValue));
    }

    /**
     * Update sanction alerts assignee
     */
    async updateSanctionAlertsAssignee(requestParameters: UpdateSanctionAlertsAssigneeRequest, initOverrides?: RequestInit): Promise<ApiSanctionAlerts> {
        const response = await this.updateSanctionAlertsAssigneeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update sanction alerts status
     */
    async updateSanctionAlertsStatusesRaw(requestParameters: UpdateSanctionAlertsStatusesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiSanctionAlerts>> {
        if (requestParameters.apiBulkStatus === null || requestParameters.apiBulkStatus === undefined) {
            throw new runtime.RequiredError('apiBulkStatus','Required parameter requestParameters.apiBulkStatus was null or undefined when calling updateSanctionAlertsStatuses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/statuses`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ApiBulkStatusToJSON(requestParameters.apiBulkStatus),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiSanctionAlertsFromJSON(jsonValue));
    }

    /**
     * Update sanction alerts status
     */
    async updateSanctionAlertsStatuses(requestParameters: UpdateSanctionAlertsStatusesRequest, initOverrides?: RequestInit): Promise<ApiSanctionAlerts> {
        const response = await this.updateSanctionAlertsStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update related screening alerts status
     */
    async updateScreeningRelatedAlertsStatusesRaw(requestParameters: UpdateScreeningRelatedAlertsStatusesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.screeningAlertId === null || requestParameters.screeningAlertId === undefined) {
            throw new runtime.RequiredError('screeningAlertId','Required parameter requestParameters.screeningAlertId was null or undefined when calling updateScreeningRelatedAlertsStatuses.');
        }

        if (requestParameters.apiRelatedAlertBulkStatus === null || requestParameters.apiRelatedAlertBulkStatus === undefined) {
            throw new runtime.RequiredError('apiRelatedAlertBulkStatus','Required parameter requestParameters.apiRelatedAlertBulkStatus was null or undefined when calling updateScreeningRelatedAlertsStatuses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{screeningAlertId}/related-alerts/statuses`.replace(`{${"screeningAlertId"}}`, encodeURIComponent(String(requestParameters.screeningAlertId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ApiRelatedAlertBulkStatusToJSON(requestParameters.apiRelatedAlertBulkStatus),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update related screening alerts status
     */
    async updateScreeningRelatedAlertsStatuses(requestParameters: UpdateScreeningRelatedAlertsStatusesRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateScreeningRelatedAlertsStatusesRaw(requestParameters, initOverrides);
    }

}
